import { Component, OnInit, AfterViewInit, OnDestroy, ViewEncapsulation, HostListener, ElementRef, ViewChild } from '@angular/core';
import { FeesOverdueReportService } from './fees-overdue-report.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { commonFunctionService } from 'src/app/utils/commonFunctions';
import { ToWords } from 'to-words';
import CurrencyList from 'currency-list';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import * as strings from "../stringFiles/feesOverdue.json";

declare var customToastr: any;
declare var $: any;

@Component({
  selector: 'app-fees-overdue-report',
  templateUrl: './fees-overdue-report.component.html',
  styleUrls: [
    './fees-overdue-report.component.css',
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FeesOverdueReportComponent implements OnInit, AfterViewInit, OnDestroy {

  currencyType = localStorage.getItem('currency')
  currencyName = CurrencyList.get(this.currencyType)
  strings = strings;
  toWords = new ToWords({
    converterOptions: {
      currency: true,
      currencyOptions: {
        name: this.currencyName.name,
        plural: this.currencyName.name_plural,
        symbol: this.currencyName.symbol,
        fractionalUnit: {
          name: this.currencyName.name,
          plural: this.currencyName.name_plural,
          symbol: this.currencyName.symbol,
        },
      }
    }
  });

  /** ========== FILTERS ========== */
  wingListData: any[] = [];
  classStandardData: any[] = [];
  classSectionData: any[] = [];
  studentList: any[] = [];
  feeOptions: any[] = [];

  selectedWings: any[] = [];
  selectedClasses: any[] = [];
  selectedSections: any[] = [];
  selectedStudents: any[] = [];
  selectedFeeTypes: any[] = [];

  appliedWings: any[] = [];
  appliedClasses: any[] = [];
  appliedSections: any[] = [];
  appliedFeeTypes: any[] = [];
  appliedStudent: any[] = [];
  appliedStatus: any = { label: 'All', value: 'All' };
  appliedSort: any = { label: 'All', value: 'All' };

  appliedWingsLabel: string = 'All';
  appliedClassesLabel: string = 'All';
  appliedSectionsLabel: string = 'All';
  appliedStudentLabel: string = 'All';
  appliedStatusLabel: string = 'All';
  appliedSortLabel: string = 'All';
  appliedFeeLabel: string = 'All';
  optionHeaderIndex: string = "";
  enableReset: boolean = false;


  isColumnSelectionModalOpen = false;
  exportColumns: any[] = [];
  selectedExportColumns: any[] = [];
  selectAllExportColumns = true;


  studentsWithNoRollNumberList: any[] = [];
  isSortNotAllowedModalOpen = false;

  /** ========== STATUS DROPDOWN ========== */
  statusOptions: any[] = [
    { label: 'All', value: 'All' },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Deactive' }
  ];
  selectedStatus: any = { label: 'All', value: 'All' };

  /** ========== CUSTOM FEE DROPDOWN ========== */
  isFeeDropdownOpen = false;
  feeSelectionData: any = {
    termFees: {
      label: this.strings.termFees,
      isSelected: true,
      isExpanded: false,
      feesTypes: []
    },
    typeFees: {
      label: this.strings.typeFees,
      isSelected: true,
      isExpanded: false,
      feesTypes: []
    },
    transportFees: {
      label: this.strings.transportFees,
      isSelected: true,
      isExpanded: false,
      feesTypes: []
    },
    otherFees: {
      label: this.strings.otherFees,
      isSelected: true,
      isExpanded: false,
      feesTypes: []
    }
  };

  isFilterExpanded = false;
  feeSearchText: string = '';
  allFeesSelected: boolean = true;
  enableBackButton: boolean = false;

  /** ========== LOADERS ========== */
  loadingWingData = false;
  loadingClassData = false;
  loadingSectionData = false;
  loadingStudentData = false;
  loadingStatData = false;
  loadingClassTileData = false;
  loadingClassTableData = false;
  loadingFeeListData = false;

  /** ========== DATA ========== */
  studentStatData: any[] = [];
  overdueFeeData: any[] = [];
  tableHeaderData: any[] = [];
  tableBodyData: any[] = [];


  academicId: any = 0;
  schoolCurrencySymbol: string;
  showResetButton: boolean = false;

  /* ========== SORT DROPDOWN ========== */
  isSortDropdownOpen = false;
  sortSelectionData: any = {
    studentId: {
      label: this.strings.studentId,
      isExpanded: false,
      options: [
        { label: this.strings.ascending, value: this.strings.ascendingValue, isSelected: true },
        { label: this.strings.descending, value: this.strings.descendingValue, isSelected: false }
      ]
    },
    rollNumber: {
      label: this.strings.rollNumber,
      isExpanded: false,
      options: [
        { label: this.strings.ascending, value: this.strings.ascendingValue, isSelected: false },
        { label: this.strings.descending, value: this.strings.descendingValue, isSelected: false }
      ]
    }
  };

  /** ========== TABLE COLUMNS ========== */
  feesColumnData: any[] = [];
  feesColumnIndex: any = null;

  /** ========== PAGINATION ========== */
  pageNumbers: any[] = [1, 2, 3];
  startingPageNumber = 1;
  maxPageNumber = 3;
  resultAvailable: number = 0;
  classViewCurrentPage = 1;
  classViewPageLimit = 12;
  tableViewCurrentPage = 1;
  tableViewPageLimit = 10;

  /** ========== EXPORT MODAL ========== */
  isExportingReport = false;
  emailAddresses = '';

  /** ========== TRANSLATION SUBSCRIPTION ========== */
  langChangeSubscription: Subscription;
  selectedText: string = 'selected';
  allText: string = 'All';
  activeText: string = 'Active';
  inactiveText: string = 'Inactive';
  studentIdText: string = 'Student Id';
  rollNumberText: string = 'Roll Number';
  ascendingText: string = 'Ascending';
  descendingText: string = 'Descending';

  constructor(private service: FeesOverdueReportService, private eRef: ElementRef, private commonFunctionService: commonFunctionService, private translate: TranslateService) { }

  // Initialize component and load initial data
  async ngOnInit(): Promise<void> {
    const schoolData = localStorage.getItem("schoolAllInfo");
    const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
    this.academicId = schoolInfo?.currentAcademicId;
    this.schoolCurrencySymbol = schoolInfo?.schoolCurrencySymbol;
    this.loadingFeeListData = true;
    this.loadingStatData = true;

    await this.getFeeListData();
    await this.getWingList();
    this.appliedWings = this.selectedWings;
    await this.getClassList(true);
    this.appliedClasses = this.selectedClasses;
    await this.getSectionList(true);
    this.appliedSections = this.selectedSections;
    await this.getStatData();
    this.generatePageNumbers();
    this.tileDataOrTableData(true);
    this.generatePageNumbers();

    this.appliedSortLabel = this.getSelectedSortLabel();
    this.appliedSort = {
      label: this.appliedSortLabel,
      value: this.getSortOrder()
    };

    this.showResetButton = false;

    // Subscribe to language changes for reactive translations
    this.updateSelectedText();
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateSelectedText();
      // Update applied labels with translated "All" text
      this.updateAppliedLabelsWithTranslation();
    });

    // Initialize applied labels with translated text after translations are loaded
    setTimeout(() => {
      this.updateAppliedLabelsWithTranslation();
      // Set initial applied labels if they are empty (initial state)
      if (!this.appliedWingsLabel && this.appliedWings.length === this.wingListData.length) {
        this.appliedWingsLabel = this.allText;
      }
      if (!this.appliedClassesLabel && this.appliedClasses.length === this.classStandardData.length) {
        this.appliedClassesLabel = this.allText;
      }
      if (!this.appliedSectionsLabel && this.appliedSections.length === this.classSectionData.length) {
        this.appliedSectionsLabel = this.allText;
      }
      if (!this.appliedStudentLabel && this.appliedStudent.length === this.studentList.length) {
        this.appliedStudentLabel = this.allText;
      }
      if (!this.appliedStatusLabel) {
        if (this.appliedStatus.value === 'All') {
          this.appliedStatusLabel = this.allText;
        } else if (this.appliedStatus.value === 'Active') {
          this.appliedStatusLabel = this.activeText;
        } else if (this.appliedStatus.value === 'Deactive') {
          this.appliedStatusLabel = this.inactiveText;
        }
      }
      if (!this.appliedFeeLabel && this.getSelectedFeesCount() === this.getTotalFeesCount()) {
        this.appliedFeeLabel = this.allText;
      }
    }, 100);
  }

  // Update applied labels with translated text
  updateAppliedLabelsWithTranslation() {
    if (this.appliedWings.length === this.wingListData.length && this.wingListData.length > 0) {
      this.appliedWingsLabel = this.allText;
    }
    if (this.appliedClasses.length === this.classStandardData.length && this.classStandardData.length > 0) {
      this.appliedClassesLabel = this.allText;
    }
    if (this.appliedSections.length === this.classSectionData.length && this.classSectionData.length > 0) {
      this.appliedSectionsLabel = this.allText;
    }
    if (this.appliedStudent.length === this.studentList.length && this.studentList.length > 0) {
      this.appliedStudentLabel = this.allText;
    }
    if (this.appliedStatus.value === 'All') {
      this.appliedStatusLabel = this.allText;
    } else if (this.appliedStatus.value === 'Active') {
      this.appliedStatusLabel = this.activeText;
    } else if (this.appliedStatus.value === 'Deactive') {
      this.appliedStatusLabel = this.inactiveText;
    }
    if (this.getSelectedFeesCount() === this.getTotalFeesCount() && this.getTotalFeesCount() > 0) {
      this.appliedFeeLabel = this.allText;
    }

    // Update status options with translations
    this.statusOptions[0].label = this.allText;
    this.statusOptions[1].label = this.activeText;
    this.statusOptions[2].label = this.inactiveText;

    // Update selected status label
    if (this.selectedStatus.value === 'All') {
      this.selectedStatus.label = this.allText;
    } else if (this.selectedStatus.value === 'Active') {
      this.selectedStatus.label = this.activeText;
    } else if (this.selectedStatus.value === 'Deactive') {
      this.selectedStatus.label = this.inactiveText;
    }

    // Update sort selection data labels
    this.updateSortLabels();
  }

  // Update labels in sortSelectionData using translated strings
  updateSortLabels() {
    this.sortSelectionData.studentId.label = this.studentIdText;
    this.sortSelectionData.rollNumber.label = this.rollNumberText;
    this.sortSelectionData.studentId.options[0].label = this.ascendingText;
    this.sortSelectionData.studentId.options[1].label = this.descendingText;
    this.sortSelectionData.rollNumber.options[0].label = this.ascendingText;
    this.sortSelectionData.rollNumber.options[1].label = this.descendingText;

    // Refresh the applied sort label
    this.appliedSortLabel = this.getSelectedSortLabel();
  }

  // Update cached translation text when language changes
  updateSelectedText() {
    this.translate.get('selected').subscribe((translation: string) => {
      this.selectedText = translation || 'selected';
    });
    this.translate.get('all').subscribe((translation: string) => {
      this.allText = translation || this.strings.allValue || 'All';
    });
    this.translate.get('active').subscribe((translation: string) => {
      this.activeText = translation || 'Active';
    });
    this.translate.get('inactive').subscribe((translation: string) => {
      this.inactiveText = translation || 'Inactive';
    });
    this.translate.get('studentId').subscribe((translation: string) => {
      this.studentIdText = translation || this.strings.studentId || 'Student Id';
      this.updateSortLabels();
    });
    this.translate.get('rollNumber').subscribe((translation: string) => {
      this.rollNumberText = translation || this.strings.rollNumber || 'Roll Number';
      this.updateSortLabels();
    });
    this.translate.get('ascending').subscribe((translation: string) => {
      this.ascendingText = translation || this.strings.ascending || 'Ascending';
      this.updateSortLabels();
    });
    this.translate.get('descending').subscribe((translation: string) => {
      this.descendingText = translation || this.strings.descending || 'Descending';
      this.updateSortLabels();
    });
  }

  // Clean up subscriptions
  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  // Initialize tooltips after view is initialized
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 100);
  }

  // Check if any dropdown is currently loading data
  isAnyDropdownLoading(): boolean {
    return this.loadingWingData || this.loadingClassData || this.loadingSectionData || this.loadingStudentData || this.loadingFeeListData;
  }

  @ViewChild('feeDropdownContainer', { read: ElementRef }) feeDropdownRef!: ElementRef;
  @ViewChild('sortDropdownContainer', { read: ElementRef }) sortDropdownRef!: ElementRef;
  @ViewChild('feeSearchInput') feeSearchInput!: ElementRef;

  @HostListener('document:click', ['$event'])
  // Handle click outside dropdowns to close them
  clickout(event: any) {
    if (this.feeDropdownRef && !this.feeDropdownRef.nativeElement.contains(event.target)) {
      this.isFeeDropdownOpen = false;
    }
    if (this.sortDropdownRef && !this.sortDropdownRef.nativeElement.contains(event.target)) {
      this.isSortDropdownOpen = false;
    }
  }

  // Close the fee dropdown
  closeFeeDropdown() {
    this.isFeeDropdownOpen = false;
  }

  // Toggle table header options menu for a specific column
  openTableHeadersOption(index) {
    if (index === this.optionHeaderIndex) {
      this.optionHeaderIndex = "";
    } else {
      this.optionHeaderIndex = index;
    }
  }

  // Close the table header options menu
  closeCollapseOptionTable() {
    this.optionHeaderIndex = "";
  }

  // Update table column order by swapping default column
  async updateTableColumn(currentSlug, newSlug) {
    const currentSlugDataIndex = this.tableHeaderData.findIndex((item) => {
      const data = item as any;
      return data.slug === currentSlug;
    });
    const newSlugDataIndex = this.tableHeaderData.findIndex((item) => {
      const data = item as any;
      return data.slug === newSlug;
    });
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const slugCurrentData = this.tableHeaderData[currentSlugDataIndex];
      const slugNewData = this.tableHeaderData[newSlugDataIndex];
      const currentInfo = slugCurrentData as any;
      const newInfo = slugNewData as any;
      currentInfo.isDefault = 0;
      newInfo.isDefault = 1;
      if (this.tableHeaderData.length > 0) {
        this.tableHeaderData[currentSlugDataIndex] = newInfo;
        this.tableHeaderData[newSlugDataIndex] = currentInfo;
      }
    }
  }

  // Clear fee search text and reset expanded states
  clearFeeSearch() {
    this.feeSearchText = '';
    Object.keys(this.feeSelectionData).forEach((categoryKey) => {
      const category = this.feeSelectionData[categoryKey];
      if (category.feesTypes) {
        category.feesTypes.forEach((feeType: any) => {
          feeType.isExpanded = false;
        });
      }
    });
  }

  // Toggle select/deselect all fees across all categories
  toggleSelectAllFees() {
    Object.keys(this.feeSelectionData).forEach((categoryKey) => {
      const category = this.feeSelectionData[categoryKey];
      if (category.feesTypes) {
        category.feesTypes.forEach((feeType: any) => {
          if (feeType.feesSubTypes) {
            feeType.feesSubTypes.forEach((feeSuperSubType: any) => {
              if (feeSuperSubType.isSelectable) {
                feeSuperSubType.isSelected = this.allFeesSelected;
              }
            });
            const selectableFeesSubTypes = feeType.feesSubTypes.filter((fee: any) => fee.isSelectable);
            feeType.isSelected = selectableFeesSubTypes.length > 0 && selectableFeesSubTypes.every((fee: any) => fee.isSelected);
          } else if (feeType.isSelectable) {
            feeType.isSelected = this.allFeesSelected;
          }
        });
        if (categoryKey === 'termFees') {
          const selectableTerms = category.feesTypes.filter((term: any) => term.isDueDatePassed === 1);
          category.isSelected = selectableTerms.length > 0 && selectableTerms.every((term: any) => term.isSelected);
        } else if (categoryKey === 'otherFees') {
          category.isSelected = category.feesTypes.every((feeType: any) => feeType.isSelected);
        } else {
          const selectableFeesTypes = category.feesTypes.filter((feeType: any) => feeType.isSelectable);
          category.isSelected = selectableFeesTypes.length > 0 && selectableFeesTypes.every((feeType: any) => feeType.isSelected);
        }
      }
    });
  }

  // Check if fee group should be displayed based on search text
  shouldShowFeeGroup(categoryKey: string): boolean {
    if (!this.feeSearchText || this.feeSearchText.trim() === '') {
      return true;
    }

    const searchLower = this.feeSearchText.toLowerCase();
    const category = this.feeSelectionData[categoryKey];

    if (category.label.toLowerCase().includes(searchLower)) {
      category.isExpanded = true;
      return true;
    }
    if (category.feesTypes) {
      const hasMatch = category.feesTypes.some((feeType: any) => {
        if (feeType.name.toLowerCase().includes(searchLower)) {
          return true;
        }
        if (feeType.feesSubTypes) {
          return feeType.feesSubTypes.some((feeSuperSubType: any) =>
            feeSuperSubType.name.toLowerCase().includes(searchLower)
          );
        }
        return false;
      });

      if (hasMatch) {
        category.isExpanded = true;
      }
      return hasMatch;
    }

    return false;
  }

  // Check if category has any matching items for search text
  hasAnySearchMatch(categoryKey: string): boolean {
    if (!this.feeSearchText || this.feeSearchText.trim() === '') {
      return true;
    }

    const searchLower = this.feeSearchText.toLowerCase();
    const category = this.feeSelectionData[categoryKey];

    if (!category || !category.feesTypes) {
      return false;
    }

    return category.feesTypes.some((feeType: any) => {
      if (feeType.name.toLowerCase().includes(searchLower)) {
        return true;
      }
      if (feeType.feesSubTypes) {
        return feeType.feesSubTypes.some((feeSuperSubType: any) =>
          feeSuperSubType.name.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  }

  // Check if fee child item should be displayed based on search text
  shouldShowFeeChild(categoryKey: string, feeTypeIndex: number): boolean {
    if (!this.feeSearchText || this.feeSearchText.trim() === '') {
      return true;
    }

    const searchLower = this.feeSearchText.toLowerCase();
    const feeType = this.feeSelectionData[categoryKey].feesTypes[feeTypeIndex];

    if (categoryKey === 'termFees') {
      const feeTypeNameMatches = feeType.name.toLowerCase().includes(searchLower);
      const hasMatchingFeesSuperSubTypes = feeType.feesSubTypes && feeType.feesSubTypes.some((feeSuperSubType: any) =>
        feeSuperSubType.name.toLowerCase().includes(searchLower)
      );

      if (feeTypeNameMatches) {
        feeType.isExpanded = false;
        return true;
      }

      if (hasMatchingFeesSuperSubTypes) {
        const anySiblingHasMatchingFeesSuperSubTypes = this.feeSelectionData[categoryKey].feesTypes.some((sibling: any) => {
          const siblingNameMatches = sibling.name.toLowerCase().includes(searchLower);
          if (siblingNameMatches) {
            return false;
          }
          if (sibling.feesSubTypes) {
            return sibling.feesSubTypes.some((feeSuperSubType: any) =>
              feeSuperSubType.name.toLowerCase().includes(searchLower)
            );
          }
          return false;
        });

        if (anySiblingHasMatchingFeesSuperSubTypes) {
          feeType.isExpanded = true;
          return true;
        }
      }

      return false;
    }

    if (categoryKey === 'otherFees') {
      if (feeType.name.toLowerCase().includes(searchLower)) {
        feeType.isExpanded = true;
        return true;
      }

      if (feeType.feesSubTypes) {
        const hasMatchingFeesSuperSubType = feeType.feesSubTypes.some((feeSuperSubType: any) =>
          feeSuperSubType.name.toLowerCase().includes(searchLower)
        );
        if (hasMatchingFeesSuperSubType) {
          feeType.isExpanded = true;
          return true;
        }
      }

      return false;
    }
    if (feeType.name.toLowerCase().includes(searchLower)) {
      feeType.isExpanded = true;
      return true;
    }

    if (feeType.feesSubTypes) {
      const hasMatch = feeType.feesSubTypes.some((feeSuperSubType: any) =>
        feeSuperSubType.name.toLowerCase().includes(searchLower)
      );
      if (hasMatch) {
        feeType.isExpanded = true;
      }
      return hasMatch;
    }

    return false;
  }

  // Check if specific fee item should be displayed based on search text
  shouldShowFeeItem(categoryKey: string, feeTypeIndex: number, itemIndex: number): boolean {
    if (!this.feeSearchText || this.feeSearchText.trim() === '') {
      return true;
    }

    const searchLower = this.feeSearchText.toLowerCase();
    const item = this.feeSelectionData[categoryKey].feesTypes[feeTypeIndex].feesSubTypes[itemIndex];

    return item.name.toLowerCase().includes(searchLower);
  }

  // Get filtered and sorted term children with matched items first
  getFilteredAndSortedTermChildren(termIndex: number): any[] {
    if (!this.feeSearchText || this.feeSearchText.trim() === '') {
      return this.feeSelectionData.termFees.feesTypes[termIndex].feesSubTypes;
    }

    const searchLower = this.feeSearchText.toLowerCase();
    const feesSubTypes = this.feeSelectionData.termFees.feesTypes[termIndex].feesSubTypes;

    const matched: any[] = [];
    const unmatched: any[] = [];

    feesSubTypes.forEach((feeSubType: any) => {
      if (feeSubType.name.toLowerCase().includes(searchLower)) {
        matched.push(feeSubType);
      } else {
        unmatched.push(feeSubType);
      }
    });

    return [...matched, ...unmatched];
  }

  // Fetch wing list data from service
  async getWingList() {
    this.loadingWingData = true;
    try {
      const response: any = (await firstValueFrom(this.service.getWingListData()));
      if (response.status && response.body) {
        this.wingListData = response.body.classCategoryListDetails;
        this.selectedWings = this.wingListData;
      } else {
        const wingListError = response.body.message ? response.body.message : await firstValueFrom(this.translate.get('wingListError'));
        customToastr(wingListError, 'error');
      }
    } catch (error) {
      const wingError = error.message ? error.message : await firstValueFrom(this.translate.get('somethingWentWrong'));
      customToastr(wingError, 'error');
    }
    this.loadingWingData = false;
  }

  // Fetch fee list data from service
  async getFeeListData() {
    this.loadingFeeListData = true;
    try {
      const params = {
        lang: "en",
        academicId: this.academicId
      };
      const response: any = await firstValueFrom(this.service.getFeeListData(params));
      if (response.status && response.body) {
        this.mapFeeDataToSelectionStructure(response.body);
      } else {
        const feeListError = response.body?.message ? response.body.message : await firstValueFrom(this.translate.get('fetchListError'));
        customToastr(feeListError, 'error');
      }
    } catch (error) {
      const errorInFetchingList = await firstValueFrom(this.translate.get('fetchListError'));
      customToastr(errorInFetchingList, 'error');
    }
    this.loadingFeeListData = false;
  }

  // Map fee data from API response to selection structure
  mapFeeDataToSelectionStructure(data: any) {
    if (data.feesTerms && data.feesTerms.length > 0) {
      this.feeSelectionData.termFees.feesTypes = data.feesTerms.map((term: any) => ({
        name: term.feeTermName,
        isSelected: term.isDueDatePassed === 1,
        isExpanded: false,
        termId: term.feeTermId,
        isDueDatePassed: term.isDueDatePassed,
        feesSubTypes: term.termFeeList.map((fee: any) => ({
          name: fee.feeTypeName,
          isSelected: term.isDueDatePassed === 1,
          isSelectable: term.isDueDatePassed === 1,
          feeTypeId: fee.feeTypeId
        }))
      }));
      this.feeSelectionData.termFees.feesTypes.forEach((term: any) => {
        const selectableFeesSubTypes = term.feesSubTypes.filter((fee: any) => fee.isSelectable);
        term.isSelected = selectableFeesSubTypes.length > 0 && selectableFeesSubTypes.every((fee: any) => fee.isSelected);
      });
      const selectableTerms = this.feeSelectionData.termFees.feesTypes.filter((term: any) => term.isDueDatePassed === 1);
      this.feeSelectionData.termFees.isSelected = selectableTerms.length > 0 && selectableTerms.every((term: any) => term.isSelected);
    }

    if (data.typeFeeList && data.typeFeeList.length > 0) {
      this.feeSelectionData.typeFees.feesTypes = data.typeFeeList.map((fee: any) => ({
        name: fee.feeTypeName,
        isSelected: fee.isDueDatePassed === 1,
        isSelectable: fee.isDueDatePassed === 1,
        feeTypeId: fee.feeTypeId,
        isDueDatePassed: fee.isDueDatePassed
      }));
      const selectableTypeFees = this.feeSelectionData.typeFees.feesTypes.filter((fee: any) => fee.isSelectable);
      this.feeSelectionData.typeFees.isSelected = selectableTypeFees.length > 0 && selectableTypeFees.every((fee: any) => fee.isSelected);
    }

    if (data.busTermList && data.busTermList.length > 0) {
      this.feeSelectionData.transportFees.feesTypes = data.busTermList.map((bus: any) => ({
        name: bus.busStopTermName,
        isSelected: bus.isDueDatePassed === 1,
        isSelectable: bus.isDueDatePassed === 1,
        busStopTermId: bus.busStopTermId,
        isDueDatePassed: bus.isDueDatePassed
      }));
      const selectableTransportFees = this.feeSelectionData.transportFees.feesTypes.filter((fee: any) => fee.isSelectable);
      this.feeSelectionData.transportFees.isSelected = selectableTransportFees.length > 0 && selectableTransportFees.every((fee: any) => fee.isSelected);
    }

    if (data.otherFeeList && data.otherFeeList.length > 0) {
      this.feeSelectionData.otherFees.feesTypes = data.otherFeeList.map((category: any) => ({
        name: category.otherFeeName,
        isSelected: true,
        isExpanded: false,
        otherFeeId: category.otherFeeId,
        feesSubTypes: category.otherFeeTermList.map((term: any) => ({
          name: term.otherFeeTermName,
          isSelected: term.isDueDatePassed === 1,
          isSelectable: term.isDueDatePassed === 1,
          otherFeeTermId: term.otherFeeTermId,
          isDueDatePassed: term.isDueDatePassed
        }))
      }));
      this.feeSelectionData.otherFees.feesTypes.forEach((category: any) => {
        const selectableFeesSubTypes = category.feesSubTypes.filter((fee: any) => fee.isSelectable);
        category.isSelected = selectableFeesSubTypes.length > 0 && selectableFeesSubTypes.every((fee: any) => fee.isSelected);
      });
      this.feeSelectionData.otherFees.isSelected = this.feeSelectionData.otherFees.feesTypes.every((category: any) => category.isSelected);
    }

    this.updateAllFeesSelected();
  }

  // Fetch statistics data for fees overdue report
  async getStatData() {
    try {
      if (!this.allFeesSelected && this.getSelectedFeesCount() === 0) {
        const errorInFeeSelection = await firstValueFrom(this.translate.get('feeSelectionError'));
        customToastr(errorInFeeSelection, 'error');
        return;
      } else if (!this.selectedWings.length) {
        const errorInWingSelection = await firstValueFrom(this.translate.get('wingSelectionError'));
        customToastr(errorInWingSelection, 'error');
        return;
      } else if (!this.selectedClasses.length) {
        const errorInClassSelection = await firstValueFrom(this.translate.get('classSelectionError'));
        customToastr(errorInClassSelection, 'error');
        return;
      } else if (!this.selectedSections.length) {
        const errorInSelectedSection = await firstValueFrom(this.translate.get('sectionSelectionError'));
        customToastr(errorInSelectedSection, 'error');
        return;
      }
      this.loadingStatData = true;
      const getSelectedId = (selectedArray: any[], idKey: string) => {
        return selectedArray.map(item => item[idKey]);
      };
      const payload = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: getSelectedId(this.appliedWings, 'categoryId'),
        classStandardId: getSelectedId(this.appliedClasses, 'pkClassStandardsId'),
        classId: getSelectedId(this.appliedSections, 'classId'),
        termId: this.getFeeIds('termFees'),
        typeId: this.getFeeIds('typeFees'),
        busId: this.getFeeIds('transportFees'),
        otherFeeId: this.getFeeIds('otherFees'),
        studentIdList: this.appliedStudent.length === this.studentList.length ? "All" : this.appliedStudent.map(s => s.studentId),
        selectedFilter: this.appliedStatus.value
      };

      const response: any = await firstValueFrom(this.service.getFeesOverdueReportStats(payload));
      if (response.status && response.body) {
        this.studentStatData = response.body.feesCount;
        this.resultAvailable = response.body.resultAvailable;
      } else {
        const errorInFetchStat = response.message ? response.message : await firstValueFrom(this.translate.get('fetchStatError'));
        customToastr(errorInFetchStat, 'error');
      }
    } catch (error) {
      const errorInFetchStat = await firstValueFrom(this.translate.get('fetchStatError'));
      customToastr(errorInFetchStat, 'error');
    }
    this.loadingStatData = false;
  }

  // Get array of selected fee IDs for a specific category
  getFeeIds(categoryKey: string): any {
    const category = this.feeSelectionData[categoryKey];
    if (!category || !category.feesTypes || category.feesTypes.length === 0) return [];

    let ids: any[] = [];

    if (categoryKey === 'termFees') {
      category.feesTypes.forEach((term: any) => {
        if (term.isSelected && term.isDueDatePassed === 1) {
          ids.push(term.termId);
        }
      });
    } else if (categoryKey === 'typeFees') {
      category.feesTypes.forEach((fee: any) => {
        if (fee.isSelected && fee.isDueDatePassed === 1) {
          ids.push(fee.feeTypeId);
        }
      });
    } else if (categoryKey === 'transportFees') {
      category.feesTypes.forEach((fee: any) => {
        if (fee.isSelected && fee.isDueDatePassed === 1) {
          ids.push(fee.busStopTermId);
        }
      });
    } else if (categoryKey === 'otherFees') {
      category.feesTypes.forEach((cat: any) => {
        if (cat.feesSubTypes) {
          cat.feesSubTypes.forEach((term: any) => {
            if (term.isSelected && term.isDueDatePassed === 1) {
              ids.push(term.otherFeeTermId);
            }
          });
        }
      });
    }
    return ids;
  }

  // Toggle filter expansion state
  expandAllFilterItems() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  // Reset all filters to default state and reload data
  async resetAllFilter() {
    this.selectedWings = [];
    this.selectedClasses = [];
    this.selectedSections = [];
    this.selectedStudents = [];
    this.appliedWings = [];
    this.appliedStatus = { label: this.allText, value: 'All' };
    this.appliedClasses = [];
    this.appliedSections = [];
    this.appliedFeeTypes = [];
    this.appliedStudent = [];

    this.classStandardData = [];
    this.classSectionData = [];
    this.studentList = [];
    this.selectedFeeTypes = [];
    this.selectedStatus = { label: this.allText, value: 'All' };
    this.loadingFeeListData = true;
    this.loadingStatData = true;

    this.tableHeaderData = [];
    this.tableBodyData = [];

    this.startingPageNumber = 1;
    this.classViewCurrentPage = 1;
    this.tableViewCurrentPage = 1;
    this.classViewPageLimit = 12;
    this.tableViewPageLimit = 10;

    await this.getFeeListData();
    await this.getWingList();
    this.appliedWings = this.selectedWings;
    await this.getClassList(true);
    this.appliedClasses = this.selectedClasses;
    await this.getSectionList(true);
    this.appliedSections = this.selectedSections;
    await this.getStatData();
    this.generatePageNumbers();

    this.showResetButton = false;
    this.tileDataOrTableData(true);

    this.appliedWingsLabel = this.allText;
    this.appliedClassesLabel = this.allText;
    this.appliedSectionsLabel = this.allText;
    this.appliedStudentLabel = this.allText;
    this.appliedStatusLabel = this.allText;
    this.appliedFeeLabel = this.allText;
    this.enableReset = false;
    this.enableBackButton = false;

    this.resetSortToDefault();

  }

  // Apply selected filters and update applied labels
  async applyFilter() {
    if (this.selectedSections.length === 1 && this.selectedClasses.length === 1 && this.selectedWings.length === 1 && this.selectedStudents.length === 0) {
      const studentSelectionError = await firstValueFrom(this.translate.get('studentSelectionError'));
      customToastr(studentSelectionError, 'error');
      return;
    }

    this.appliedWings = this.selectedWings.length > 0 ? this.selectedWings : [];
    this.appliedClasses = this.selectedClasses.length > 0 ? this.selectedClasses : [];
    this.appliedSections = this.selectedSections.length > 0 ? this.selectedSections : [];
    this.appliedStudent = this.selectedStudents.length > 0 ? this.selectedStudents : [];
    this.appliedFeeTypes = this.selectedFeeTypes.length > 0 ? this.selectedFeeTypes : [];
    this.appliedStatus = this.selectedStatus;

    this.appliedWingsLabel = this.appliedWings.length > 0 ? (this.appliedWings.length === this.wingListData.length ? this.allText : this.appliedWings.length + ' ' + this.selectedText) : this.strings.noneValue;
    this.appliedClassesLabel = this.appliedClasses.length > 0 ? (this.appliedClasses.length === this.classStandardData.length ? this.allText : this.appliedClasses.length + ' ' + this.selectedText) : this.strings.noneValue;
    this.appliedSectionsLabel = this.appliedSections.length > 0 ? (this.appliedSections.length === this.classSectionData.length ? this.allText : this.appliedSections.length + ' ' + this.selectedText) : this.strings.noneValue;
    this.appliedStudentLabel = this.appliedStudent.length > 0 ? (this.appliedStudent.length === this.studentList.length ? this.allText : this.appliedStudent.length + ' ' + this.selectedText) : this.strings.noneValue;
    // Set status label based on value using translated text
    if (this.appliedStatus.value === 'All') {
      this.appliedStatusLabel = this.allText;
    } else if (this.appliedStatus.value === 'Active') {
      this.appliedStatusLabel = this.activeText;
    } else if (this.appliedStatus.value === 'Deactive') {
      this.appliedStatusLabel = this.inactiveText;
    } else {
      this.appliedStatusLabel = this.appliedStatus.label;
    }
    this.appliedFeeLabel = this.getSelectedFeesCount() === 0 ? this.strings.noneValue : (this.getSelectedFeesCount() === this.getTotalFeesCount() ? this.allText : this.getSelectedFeesCount() + ' ' + this.selectedText);

    this.appliedSortLabel = this.getSelectedSortLabel();
    this.appliedSort = {
      label: this.appliedSortLabel,
      value: this.getSortOrder()
    };

    this.classViewCurrentPage = 1;
    this.startingPageNumber = 1;

    this.getStatData();
    this.enableReset = true;

    this.tileDataOrTableData();
  }

  // Handle wing selection change and cascade to classes/sections
  onWingChange() {
    this.showResetButton = true;
    const allWingsSelected = this.selectedWings.length === this.wingListData.length;

    if (allWingsSelected) {
      this.selectedClasses = [...this.classStandardData];
      this.selectedSections = [...this.classSectionData];
    } else {
      const selectedWingIds = this.selectedWings.map(w => w.categoryId);
      const relatedClasses = this.classStandardData.filter(cls =>
        selectedWingIds.includes(cls.categoryId)
      );

      // Update selected classes to only include those related to selected wings
      this.selectedClasses = this.selectedClasses.filter(cls =>
        selectedWingIds.includes(cls.categoryId)
      );
      if (this.selectedClasses.length === 0 && relatedClasses.length > 0) {
        this.selectedClasses = [...relatedClasses];
      }
      this.cascadeToSections();
    }
    this.getClassList();
  }

  // Fetch class list based on selected wings
  async getClassList(onLoad = false) {
    if (!onLoad) {
      this.showResetButton = true;
    }
    const wingIds = this.selectedWings.map(w => w.categoryId);
    let requestData: any;

    if (!onLoad && (wingIds && wingIds.length === 0)) {
      this.selectedClasses = [];
      this.selectedSections = [];
      this.selectedStudents = [];
      this.classStandardData = [];
      this.classSectionData = [];
      this.studentList = [];
      return;
    }

    if (wingIds.length !== this.wingListData.length && !onLoad) {
      this.loadingClassData = true;
      requestData = wingIds;
    } else {
      if (!onLoad) {
        this.loadingClassData = true;
      }
      requestData = 'All';
    }

    try {
      let body = {
        lang: "en",
        classCategoryIds: requestData
      };

      const response: any = await firstValueFrom(this.service.getClassListData(body));
      if (response.status && response.body) {
        this.classStandardData = response.body.classCategoryListData;
        const newClassIds = this.classStandardData.map(c => c.pkClassStandardsId);
        this.selectedClasses = this.selectedClasses.filter(c =>
          newClassIds.includes(c.pkClassStandardsId)
        );
        if (onLoad || this.selectedClasses.length === 0) {
          this.selectedClasses = this.classStandardData;
        }

        await this.getSectionList(onLoad);
      } else {
        const fetchClassListError = response.message ? response.message :
          await firstValueFrom(this.translate.get('fetchClassListError'));
        customToastr(fetchClassListError, 'error');
      }
    } catch (error) {
      const errorInFetchingClassList = await firstValueFrom(
        this.translate.get('fetchClassListError')
      );
      customToastr(errorInFetchingClassList, 'error');
    } finally {
      this.loadingClassData = false;
    }
  }

  // Handle class selection change and cascade to wings/sections
  onClassChange(onLoad = false) {
    if (!onLoad) {
      this.showResetButton = true;
    }
    const allClassesSelected = this.selectedClasses.length === this.classStandardData.length;

    if (allClassesSelected) {
      this.selectedWings = [...this.wingListData];
      this.selectedSections = [...this.classSectionData];
    } else {
      const selectedClassIds = this.selectedClasses.map(c => c.pkClassStandardsId);
      const selectedClassCategoryIds = this.selectedClasses.map(c => c.categoryId);
      const relatedWings = this.wingListData.filter(wing =>
        selectedClassCategoryIds.includes(wing.categoryId)
      );
      const currentWingIds = this.selectedWings.map(w => w.categoryId);
      const newWingsToAdd = relatedWings.filter(wing =>
        !currentWingIds.includes(wing.categoryId)
      );

      if (newWingsToAdd.length > 0) {
        this.selectedWings = [...this.selectedWings, ...newWingsToAdd];
      }
      this.selectedWings = this.selectedWings.filter(wing =>
        this.classStandardData.some(cls =>
          cls.categoryId === wing.categoryId &&
          selectedClassIds.includes(cls.pkClassStandardsId)
        )
      );
      this.cascadeToSections();
    }
    this.selectedStudents = [];
    this.studentList = [];

    if (!onLoad) {
      this.getSectionList();
    }
  }

  // Fetch section list based on selected classes and wings
  async getSectionList(onLoad = false) {
    if (!onLoad) {
      this.showResetButton = true;
    }

    const classIds = this.selectedClasses.map(c => c.pkClassStandardsId);
    const wingIds = this.selectedWings.map(w => w.categoryId);

    if (!onLoad && (classIds && classIds.length === 0)) {
      this.selectedSections = [];
      this.selectedStudents = [];
      this.classSectionData = [];
      this.studentList = [];
      return;
    }

    this.loadingSectionData = true;
    let requestClassIdData = classIds.length > 0 ? classIds : this.strings.allValue;
    let requestCategoryIdData = wingIds.length > 0 ? wingIds : this.strings.allValue;

    try {
      let body = {
        lang: "en",
        classStandardIds: requestClassIdData,
        classCategoryIds: requestCategoryIdData
      };

      const response: any = await firstValueFrom(
        this.service.getClassSectionListData(body)
      );

      if (response.status && response.body) {
        this.classSectionData = response.body.classSectionListData.map((section: any) => ({
          ...section,
          displayLabel: `${section.classStandardName} - ${section.classDivision}`
        }));

        const allWingsSelected = this.selectedWings.length === this.wingListData.length;
        const allClassesSelected = this.selectedClasses.length === this.classStandardData.length;

        if (allWingsSelected && allClassesSelected) {
          this.selectedSections = [...this.classSectionData];
        } else {
          const newSectionIds = this.classSectionData.map(s => s.classId);
          this.selectedSections = this.selectedSections.filter(s =>
            newSectionIds.includes(s.classId)
          );

          if (onLoad || this.selectedSections.length === 0) {
            this.selectedSections = this.classSectionData;
          }
        }
        if (!onLoad && this.selectedSections.length === 1) {
          this.sortSelectionData.studentId.options[0].isSelected = true;
          this.sortSelectionData.studentId.options[1].isSelected = false;
          this.sortSelectionData.rollNumber.options[0].isSelected = false;
          this.sortSelectionData.rollNumber.options[1].isSelected = false;

          this.selectedStudents = [];
          this.studentList = [];
          this.getStudentList();
        }
      } else {
        const fetchSectionListError = response.message ? response.message :
          await firstValueFrom(this.translate.get('fetchSectionListFail'));
        customToastr(fetchSectionListError, 'error');
      }
    } catch (error) {
      const fetchSectionListError = await firstValueFrom(
        this.translate.get('fetchSectionListFail')
      );
      customToastr(fetchSectionListError, 'error');
    } finally {
      this.loadingSectionData = false;
    }
  }

  // Handle section selection change and cascade to classes/wings
  onSectionChange(onLoad = false) {
    if (!onLoad) {
      this.showResetButton = true;
    }

    const allSectionsSelected = this.selectedSections.length === this.classSectionData.length;

    if (allSectionsSelected) {
      this.selectedClasses = [...this.classStandardData];
      this.selectedWings = [...this.wingListData];
    } else {
      const selectedSectionClassIds = this.selectedSections.map(s => s.pkClassStandardsId);
      const selectedSectionCategoryIds = this.selectedSections.map(s => s.categoryId);

      const relatedClasses = this.classStandardData.filter(cls =>
        selectedSectionClassIds.includes(cls.pkClassStandardsId)
      );

      const currentClassIds = this.selectedClasses.map(c => c.pkClassStandardsId);
      const newClassesToAdd = relatedClasses.filter(cls =>
        !currentClassIds.includes(cls.pkClassStandardsId)
      );

      if (newClassesToAdd.length > 0) {
        this.selectedClasses = [...this.selectedClasses, ...newClassesToAdd];
      }

      this.selectedClasses = this.selectedClasses.filter(cls =>
        this.classSectionData.some(sec =>
          sec.pkClassStandardsId === cls.pkClassStandardsId &&
          this.selectedSections.some(selSec => selSec.classId === sec.classId)
        )
      );

      const relatedWings = this.wingListData.filter(wing =>
        selectedSectionCategoryIds.includes(wing.categoryId)
      );

      const currentWingIds = this.selectedWings.map(w => w.categoryId);
      const newWingsToAdd = relatedWings.filter(wing =>
        !currentWingIds.includes(wing.categoryId)
      );

      if (newWingsToAdd.length > 0) {
        this.selectedWings = [...this.selectedWings, ...newWingsToAdd];
      }

      this.selectedWings = this.selectedWings.filter(wing =>
        this.selectedSections.some(sec => sec.categoryId === wing.categoryId)
      );
    }

    if (this.selectedSections.length === 1) {
      this.sortSelectionData.studentId.options[0].isSelected = true;
      this.sortSelectionData.studentId.options[1].isSelected = false;
      this.sortSelectionData.rollNumber.options[0].isSelected = false;
      this.sortSelectionData.rollNumber.options[1].isSelected = false;

      this.selectedStudents = [];
      this.studentList = [];
      this.getStudentList();
    }
  }

  // Cascade selection changes to sections based on selected classes and wings
  private cascadeToSections() {
    const selectedClassIds = this.selectedClasses.map(c => c.pkClassStandardsId);
    const selectedWingIds = this.selectedWings.map(w => w.categoryId);

    const relatedSections = this.classSectionData.filter(sec =>
      selectedClassIds.includes(sec.pkClassStandardsId) &&
      selectedWingIds.includes(sec.categoryId)
    );

    this.selectedSections = this.selectedSections.filter(sec =>
      selectedClassIds.includes(sec.pkClassStandardsId) &&
      selectedWingIds.includes(sec.categoryId)
    );

    if (this.selectedSections.length === 0 && relatedSections.length > 0) {
      this.selectedSections = [...relatedSections];
    }

    this.selectedStudents = [];
    this.studentList = [];
  }

  // Fetch student list based on selected sections and status
  async getStudentList() {
    this.loadingStudentData = true;
    try {
      const schoolData = localStorage.getItem("schoolAllInfo");
      const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
      let paramsBody = {
        lang: "en",
        classCategoryId: this.selectedSections.map(w => w.categoryId),
        classStandardId: this.selectedSections.map(s => s.pkClassStandardsId),
        classId: this.selectedSections.map(s => s.classId),
        academicId: this.academicId,
        selectedFilter: this.selectedStatus.value
      };
      const response: any = await firstValueFrom(this.service.getStudentListData(paramsBody));
      if (response.status && response.body) {
        this.studentList = response.body.studentListForFeesOverdue;
        this.selectedStudents = this.studentList;
      } else {
        const fetchStudentListError = response.message ? response.message :
          await firstValueFrom(this.translate.get('fetchStudentListFail'));
        customToastr(fetchStudentListError, 'error');
      }
    } catch (error) {
      const fetchStudentListFail = await firstValueFrom(this.translate.get('fetchStudentListFail'));
      customToastr(fetchStudentListFail, 'error');
    } finally {
      this.loadingStudentData = false;
    }
  }

  // Handle status filter change and reload students if needed
  onStatusChange() {

    this.showResetButton = true;
    if (this.selectedSections.length === 1 && this.selectedClasses.length === 1 && this.selectedWings.length === 1) {
      this.selectedStudents = [];
      this.studentList = [];
      this.getStudentList();
    }
  }

  // Handle student selection change
  onStudentChange() {
    this.showResetButton = true;
  }

  // Toggle fee dropdown visibility and focus search input
  toggleFeeDropdown() {
    this.isFeeDropdownOpen = !this.isFeeDropdownOpen;
    if (this.isFeeDropdownOpen) {
      setTimeout(() => {
        if (this.feeSearchInput && this.feeSearchInput.nativeElement) {
          this.feeSearchInput.nativeElement.focus();
        }
      }, 100);
    }
  }

  // Get count of selected fees across all categories
  getSelectedFeesCount(): number {
    let count = 0;

    this.feeSelectionData.termFees.feesTypes.forEach((term: any) => {
      term.feesSubTypes.forEach((fee: any) => {
        if (fee.isSelected) count++;
      });
    });

    this.feeSelectionData.typeFees.feesTypes.forEach((fee: any) => {
      if (fee.isSelected) count++;
    });

    this.feeSelectionData.transportFees.feesTypes.forEach((fee: any) => {
      if (fee.isSelected) count++;
    });

    this.feeSelectionData.otherFees.feesTypes.forEach((category: any) => {
      category.feesSubTypes.forEach((fee: any) => {
        if (fee.isSelected) count++;
      });
    });

    return count;
  }

  // Get total count of all available fees
  getTotalFeesCount(): number {
    let count = 0;

    this.feeSelectionData.termFees.feesTypes.forEach((term: any) => {
      count += term.feesSubTypes.length;
    });

    count += this.feeSelectionData.typeFees.feesTypes.length;

    count += this.feeSelectionData.transportFees.feesTypes.length;

    this.feeSelectionData.otherFees.feesTypes.forEach((category: any) => {
      count += category.feesSubTypes.length;
    });

    return count;
  }

  // Toggle fee category expansion state
  toggleFeeCategory(category: string) {
    this.feeSelectionData[category].isExpanded = !this.feeSelectionData[category].isExpanded;
  }

  // Toggle fee subcategory expansion state
  toggleFeeSubCategory(category: string, index: number) {
    this.feeSelectionData[category].feesTypes[index].isExpanded = !this.feeSelectionData[category].feesTypes[index].isExpanded;
  }

  // Handle term fees category selection change
  onTermFeesChange() {
    this.showResetButton = true;
    const isSelected = this.feeSelectionData.termFees.isSelected;
    this.feeSelectionData.termFees.feesTypes.forEach((term: any) => {
      if (term.isDueDatePassed === 1) {
        term.isSelected = isSelected;
        term.feesSubTypes.forEach((fee: any) => {
          fee.isSelected = isSelected;
        });
      }
    });
    this.updateAllFeesSelected();
  }

  // Handle term child selection change
  onTermChildChange(termIndex: number) {
    this.showResetButton = true;
    const term = this.feeSelectionData.termFees.feesTypes[termIndex];
    term.feesSubTypes.forEach((fee: any) => {
      if (fee.isSelectable) {
        fee.isSelected = term.isSelected;
      }
    });
    this.updateTermFeesParent();
  }

  // Update term fees parent selection state based on children
  updateTermFeesParent() {
    this.feeSelectionData.termFees.feesTypes.forEach((term: any) => {
      const selectableFeesSubTypes = term.feesSubTypes.filter((fee: any) => fee.isSelectable);
      term.isSelected = selectableFeesSubTypes.length > 0 && selectableFeesSubTypes.every((fee: any) => fee.isSelected);
    });

    const selectableTerms = this.feeSelectionData.termFees.feesTypes.filter((term: any) => term.isDueDatePassed === 1);
    this.feeSelectionData.termFees.isSelected = selectableTerms.length > 0 && selectableTerms.every((term: any) => term.isSelected);

    this.updateAllFeesSelected();
  }

  // Handle type fees category selection change
  onTypeFeesChange() {
    this.showResetButton = true;
    const isSelected = this.feeSelectionData.typeFees.isSelected;
    this.feeSelectionData.typeFees.feesTypes.forEach((fee: any) => {
      if (fee.isSelectable) {
        fee.isSelected = isSelected;
      }
    });
    this.updateAllFeesSelected();
  }

  // Handle type fee child selection change
  onTypeFeeChildChange() {
    this.showResetButton = true;
    const selectableFees = this.feeSelectionData.typeFees.feesTypes.filter((fee: any) => fee.isSelectable);
    const allSelectableSelected = selectableFees.length > 0 && selectableFees.every((fee: any) => fee.isSelected);
    this.feeSelectionData.typeFees.isSelected = allSelectableSelected;
    this.updateAllFeesSelected();
  }

  // Handle transport fees category selection change
  onTransportFeesChange() {
    this.showResetButton = true;
    const isSelected = this.feeSelectionData.transportFees.isSelected;
    this.feeSelectionData.transportFees.feesTypes.forEach((fee: any) => {
      if (fee.isSelectable) {
        fee.isSelected = isSelected;
      }
    });
    this.updateAllFeesSelected();
  }

  // Handle transport fee child selection change
  onTransportFeeChildChange() {
    this.showResetButton = true;
    const selectableFees = this.feeSelectionData.transportFees.feesTypes.filter((fee: any) => fee.isSelectable);
    const allSelectableSelected = selectableFees.length > 0 && selectableFees.every((fee: any) => fee.isSelected);
    this.feeSelectionData.transportFees.isSelected = allSelectableSelected;
    this.updateAllFeesSelected();
  }

  // Handle other fees category selection change
  onOtherFeesChange() {
    this.showResetButton = true;
    const isSelected = this.feeSelectionData.otherFees.isSelected;
    this.feeSelectionData.otherFees.feesTypes.forEach((category: any) => {
      category.isSelected = isSelected;
      category.feesSubTypes.forEach((fee: any) => {
        if (fee.isSelectable) {
          fee.isSelected = isSelected;
        }
      });
    });
    this.updateAllFeesSelected();
  }

  // Get count of default columns in table header
  getDefaultColumnsCount(): number {
    return this.tableHeaderData.filter(col => col.isDefault === 1).length;
  }

  // Handle other fee child category selection change
  onOtherFeeChildChange(categoryIndex: number) {
    this.showResetButton = true;
    const category = this.feeSelectionData.otherFees.feesTypes[categoryIndex];
    category.feesSubTypes.forEach((fee: any) => {
      if (fee.isSelectable) {
        fee.isSelected = category.isSelected;
      }
    });
    this.updateOtherFeesParent();
  }

  // Handle other fee grandchild selection change
  onOtherFeeGrandchildChange(categoryIndex: number) {
    this.showResetButton = true;
    const category = this.feeSelectionData.otherFees.feesTypes[categoryIndex];
    const selectableFees = category.feesSubTypes.filter((fee: any) => fee.isSelectable);
    const allSelectableSelected = selectableFees.length > 0 && selectableFees.every((fee: any) => fee.isSelected);
    category.isSelected = allSelectableSelected;
    this.updateOtherFeesParent();
  }

  // Update other fees parent selection state based on children
  updateOtherFeesParent() {
    this.feeSelectionData.otherFees.feesTypes.forEach((category: any) => {
      const selectableFees = category.feesSubTypes.filter((fee: any) => fee.isSelectable);
      category.isSelected = selectableFees.length > 0 && selectableFees.every((fee: any) => fee.isSelected);
    });

    const allSelected = this.feeSelectionData.otherFees.feesTypes.every((category: any) => category.isSelected);
    this.feeSelectionData.otherFees.isSelected = allSelected;

    this.updateAllFeesSelected();
  }

  // Update all fees selected state based on all categories
  updateAllFeesSelected() {
    const allTermFeesSelected = this.feeSelectionData.termFees.feesTypes.every((term: any) => {
      const selectableFees = term.feesSubTypes.filter((fee: any) => fee.isSelectable);
      return selectableFees.length === 0 || selectableFees.every((fee: any) => fee.isSelected);
    });

    const allTypeFeesSelected = (() => {
      const selectableFees = this.feeSelectionData.typeFees.feesTypes.filter((fee: any) => fee.isSelectable);
      return selectableFees.length === 0 || selectableFees.every((fee: any) => fee.isSelected);
    })();

    const allTransportFeesSelected = (() => {
      const selectableFees = this.feeSelectionData.transportFees.feesTypes.filter((fee: any) => fee.isSelectable);
      return selectableFees.length === 0 || selectableFees.every((fee: any) => fee.isSelected);
    })();

    const allOtherFeesSelected = this.feeSelectionData.otherFees.feesTypes.every((category: any) => {
      const selectableFees = category.feesSubTypes.filter((fee: any) => fee.isSelectable);
      return selectableFees.length === 0 || selectableFees.every((fee: any) => fee.isSelected);
    });

    this.allFeesSelected = allTermFeesSelected && allTypeFeesSelected && allTransportFeesSelected && allOtherFeesSelected;
  }

  // Get label for selected wings display
  get wingSelectedItemsLabel(): string {
    if (this.selectedWings.length === 0) {
      return this.strings.noneValue;
    } else if (this.selectedWings.length === this.wingListData.length && this.wingListData.length > 0) {
      return this.allText;
    } else {
      return this.selectedWings.length + ' ' + this.selectedText;
    }
  }

  // Get label for selected classes display
  get classSelectedItemsLabel(): string {
    if (this.selectedClasses.length === 0) {
      return this.strings.noneValue;
    } else if (this.selectedClasses.length === this.classStandardData.length && this.classStandardData.length > 0) {
      return this.allText;
    } else {
      return this.selectedClasses.length + ' ' + this.selectedText;
    }
  }

  // Get label for selected sections display
  get sectionSelectedItemsLabel(): string {
    if (this.selectedSections.length === 0) {
      return this.strings.noneValue;
    } else if (this.selectedSections.length === this.classSectionData.length && this.classSectionData.length > 0) {
      return this.allText;
    } else {
      return this.selectedSections.length + ' ' + this.selectedText;
    }
  }

  // Get label for selected students display
  get studentSelectedItemsLabel(): string {
    if (this.selectedStudents.length === 0) {
      return this.strings.noneValue;
    } else if (this.selectedStudents.length === this.studentList.length && this.studentList.length > 0) {
      return this.allText;
    } else {
      return this.selectedStudents.length + ' ' + this.selectedText;
    }
  }

  // Get label for selected fees display
  get feeSelectedItemsLabel(): string {
    if (this.selectedFeeTypes.length === 0) {
      return this.strings.noneValue;
    }
    const totalFeeItems = this.feeOptions.reduce((sum, group) => sum + (group.items?.length || 0), 0);
    if (this.selectedFeeTypes.length === totalFeeItems && totalFeeItems > 0) {
      return this.allText;
    } else {
      return this.selectedFeeTypes.length + ' ' + this.selectedText;
    }
  }

  // Check if category has any selectable children
  hasSelectableChildren(category: any): boolean {
    return category.feesSubTypes && category.feesSubTypes.some((fee: any) => fee.isSelectable);
  }

  // Fetch and display data for selected class tile
  async fetchSelectedClassData(data: any) {
    this.selectedClassFilter(data);
    await this.getStudentList();
    this.appliedStudent = this.studentList;
    this.overdueFeeData = [];
    this.getStatData();
    this.getStudentWiseFeeDetails();
  }

  // Fetch student-wise fee details for table view
  async getStudentWiseFeeDetails(onLoad: boolean = false) {
    if ((!this.selectedWings.length || !this.selectedClasses.length || !this.selectedSections.length || (!this.allFeesSelected && this.getSelectedFeesCount() === 0)) && !onLoad) {
      return;
    }
    this.loadingClassTableData = true;
    try {
      const getSelectedId = (selectedArray: any[], idKey: string) => {
        return selectedArray[0][idKey];
      };
      const payload = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: onLoad && this.appliedWings.length === 0 ? "All" : getSelectedId(this.appliedWings, 'categoryId'),
        classStandardId: onLoad && this.appliedClasses.length === 0 ? "All" : getSelectedId(this.appliedClasses, 'pkClassStandardsId'),
        classId: onLoad && this.appliedSections.length === 0 ? "All" : getSelectedId(this.appliedSections, 'classId'),
        termId: this.getFeeIds('termFees'),
        typeId: this.getFeeIds('typeFees'),
        busId: this.getFeeIds('transportFees'),
        otherFeeId: this.getFeeIds('otherFees'),
        studentIdList: this.appliedStudent.length === this.studentList.length ? "All" : this.appliedStudent.map(s => s.studentId),
        selectedFilter: this.appliedStatus.value,
        sortBy: this.getSortBy(),
        sortOrder: this.getSortOrder(),
        pageNumber: this.tableViewCurrentPage,
        pageLimit: this.tableViewPageLimit
      };

      const response: any = await firstValueFrom(this.service.getStudentWiseFeeDetails(payload));

      if (response.status && response.body) {
        if (this.tableHeaderData.length === 0) {
          this.tableHeaderData = response.body.reportColumnList
            ? response.body.reportColumnList
            : [];
        }
        this.maxPageNumber = response.body.maxPageNumber;
        this.generatePageNumbers();
        this.tableBodyData = response.body.reportStudentData
          ? response.body.reportStudentData
          : [];
        this.loadingClassTableData = false;
      }
    } catch (error) {
      const classDataError = await firstValueFrom(this.translate.get('classDataError'));
      customToastr(classDataError, 'error');
      this.overdueFeeData = [];
    } finally {
      this.loadingClassTileData = false;
    }
  }

  // Apply filter based on selected class tile data
  selectedClassFilter(data) {
        const wingObj = this.wingListData.find( w => w.categoryId === data.categoryId);
        const classObj = this.classStandardData.find(c => c.classStandardName === data.class);
        const sectionObj = this.classSectionData.find(s => s.classDivision === data.section && s.classStandardName === data.class);

        this.selectedWings = [];
        this.selectedClasses = [];
        this.selectedSections = [];
        this.selectedStudents = [];

        if (wingObj) {
            this.selectedWings = [wingObj];
        }
        if (classObj) {
            this.selectedClasses = [classObj];
        }
        if (sectionObj) {
            this.selectedSections = [sectionObj];
        }

    this.appliedWings = this.selectedWings;
    this.appliedClasses = this.selectedClasses;
    this.appliedSections = this.selectedSections;

    this.appliedWingsLabel = this.selectedWings.length === 1 ? this.selectedWings[0].classCategoryName : this.allText;
    this.appliedClassesLabel = this.selectedClasses.length === 1 ? this.selectedClasses[0].classStandardName : this.allText;
    this.appliedSectionsLabel = this.selectedSections.length === 1 ? this.selectedSections[0].classDivision : this.allText;

    this.startingPageNumber = 1;
    this.tableViewCurrentPage = 1;
    this.enableBackButton = true;
  }

  // Determine whether to show tile view or table view based on selections
  tileDataOrTableData(onLoad: boolean = false) {
    if (this.appliedWings.length === 1 && this.appliedClasses.length === 1 && this.appliedSections.length === 1) {
      this.overdueFeeData = [];
      this.getStudentWiseFeeDetails(onLoad);
    } else {
      this.getAllClassData(onLoad);
      this.tableHeaderData = [];
      this.tableBodyData = [];
    }
  }

  // Fetch all class data for tile view
  async getAllClassData(onLoad: boolean = false) {
    if ((!this.selectedWings.length || !this.selectedClasses.length || !this.selectedSections.length || (!this.allFeesSelected && this.getSelectedFeesCount() === 0)) && !onLoad) {
      return;
    }
    this.loadingClassTileData = true;
    try {
      const getSelectedId = (selectedArray: any[], idKey: string) => {
        return selectedArray.map(item => item[idKey]);
      };

      const payload = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: onLoad && this.appliedWings.length === 0 ? "All" : getSelectedId(this.appliedWings, 'categoryId'),
        classStandardId: onLoad && this.appliedClasses.length === 0 ? "All" : getSelectedId(this.appliedClasses, 'pkClassStandardsId'),
        classId: onLoad && this.appliedSections.length === 0 ? "All" : getSelectedId(this.appliedSections, 'classId'),
        termId: this.getFeeIds('termFees'),
        typeId: this.getFeeIds('typeFees'),
        busId: this.getFeeIds('transportFees'),
        otherFeeId: this.getFeeIds('otherFees'),
        selectedFilter: this.appliedStatus.value,
        pageNumber: this.classViewCurrentPage,
        pageLimit: this.classViewPageLimit
      };

      const response: any = await firstValueFrom(this.service.getFeesOverdueClassData(payload));

      if (response.status && response.body) {
        this.maxPageNumber = response.body.maxPageNumber;
        this.overdueFeeData = this.formatClassData(response.body.reportClassData);
        this.generatePageNumbers();
      } else {
        const classDataError = response.message ? response.message : await firstValueFrom(this.translate.get('classDataError'));
        customToastr(classDataError, 'error');
        this.overdueFeeData = [];
      }
    } catch (error) {
      const classDataError = await firstValueFrom(this.translate.get('classDataError'));
      customToastr(classDataError, 'error');
      this.overdueFeeData = [];
    } finally {
      this.loadingClassTileData = false;
    }
  }

  // Format class data for display in tiles
  formatClassData(data: any[]): any[] {
    return data.map(item => ({
      class: item.classStandard,
      section: item.classDivision,
      wing: item.categoryName,
      feeCollected: item.feeCollected,
      feeOverdue: item.feeOverdue,
      formatedFeeCollected: this.schoolCurrencySymbol + ' ' + this.formatNumber(item.feeCollected),
      formatedFeeOverdue: this.schoolCurrencySymbol + ' ' + this.formatNumber(item.feeOverdue),
      classId: item.classId,
      categoryId: item.categoryId,
      classStandardId: item.classStandardId
    }));
  }

  // Get class-wise data and update result count
  getClassWiseData() {
    this.loadingClassTableData = true;
    if (this.feesColumnData.length === 0) {
    }
    setTimeout(() => {
      this.resultAvailable = this.tableBodyData.length;
      this.loadingClassTableData = false;
    }, 600);
  }

  // Close sort dropdown
  closeSortDropdown() {
    this.isSortDropdownOpen = false;
  }

  // Toggle fees column option expansion
  expandFeesColumnOption(index: any) {
    this.feesColumnIndex = this.feesColumnIndex === index ? null : index;
  }

  // Collapse fees column options menu
  collapseFeesColumnOption() {
    event.stopPropagation();
    this.feesColumnIndex = null;
  }

  // Update fees table column order by swapping default column
  updateFeesTableColumn(currentSlug: any, newSlug: any) {
    const currentSlugDataIndex = this.feesColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === currentSlug;
    });
    const newSlugDataIndex = this.feesColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === newSlug;
    });
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const slugCurrentData = this.feesColumnData[currentSlugDataIndex];
      const slugNewData = this.feesColumnData[newSlugDataIndex];
      const currentInfo = slugCurrentData as any;
      const newInfo = slugNewData as any;
      currentInfo.isDefault = 0;
      newInfo.isDefault = 1;
      if (this.feesColumnData.length > 0) {
        this.feesColumnData[currentSlugDataIndex] = newInfo;
        this.feesColumnData[newSlugDataIndex] = currentInfo;
      }
    }
  }

  // Format number with locale-specific formatting
  formatNumber(num) {
    if (typeof num !== 'number' || isNaN(num)) {
      return num;
    }
    return num.toLocaleString('en-IN');
  }

  // Convert number to words in currency format
  generateText(num) {
    return this.toWords.convert(num, { currency: true, ignoreDecimal: true });
  }

  // Toggle sort dropdown visibility
  toggleSortDropdown() {
    this.isSortDropdownOpen = !this.isSortDropdownOpen;
  }

  // Get label for currently selected sort option
  getSelectedSortLabel(): string {
    if (this.sortSelectionData.studentId.options.some((opt: any) => opt.isSelected)) {
      const selected = this.sortSelectionData.studentId.options.find((opt: any) => opt.isSelected);
      return `${this.studentIdText}: ${selected.label}`;
    } else if (this.sortSelectionData.rollNumber.options.some((opt: any) => opt.isSelected)) {
      const selected = this.sortSelectionData.rollNumber.options.find((opt: any) => opt.isSelected);
      return `${this.rollNumberText}: ${selected.label}`;
    }

    return `${this.studentIdText}: ${this.ascendingText}`;
  }

  // Get sort field name (studentId or rollNumber)
  getSortBy(): string {
    if (this.sortSelectionData.studentId.options.some((opt: any) => opt.isSelected)) {
      return this.strings.registartionNumber;
    } else if (this.sortSelectionData.rollNumber.options.some((opt: any) => opt.isSelected)) {
      return this.strings.rollNumberValue;
    }
    return this.strings.registartionNumber;
  }

  // Get sort order (ascending or descending)
  getSortOrder(): string {
    let selectedOption: any = null;
    if (this.sortSelectionData.studentId.options.some((opt: any) => opt.isSelected)) {
      selectedOption = this.sortSelectionData.studentId.options.find((opt: any) => opt.isSelected);
    } else if (this.sortSelectionData.rollNumber.options.some((opt: any) => opt.isSelected)) {
      selectedOption = this.sortSelectionData.rollNumber.options.find((opt: any) => opt.isSelected);
    }
    return selectedOption ? selectedOption.value : this.strings.ascendingValue;
  }

  // Reset sort options to default (Student Id: Ascending)
  resetSortToDefault() {
    Object.keys(this.sortSelectionData).forEach(key => {
      this.sortSelectionData[key].options.forEach((opt: any) => opt.isSelected = false);
    });

    this.sortSelectionData.studentId.options[0].isSelected = true;
    this.appliedSort = { label: 'Student Id: Ascending', value: this.strings.ascendingValue };
    this.appliedSortLabel = 'Student Id: Ascending';
  }

  // Toggle sort category expansion state
  toggleSortCategory(category: string) {
    this.sortSelectionData[category].isExpanded = !this.sortSelectionData[category].isExpanded;
  }

  // Handle sort option change and validate roll number sorting
  async onSortOptionChange(category: string, index: number) {
    Object.keys(this.sortSelectionData).forEach(key => {
      this.sortSelectionData[key].options.forEach((opt: any) => opt.isSelected = false);
    });
    this.sortSelectionData[category].options[index].isSelected = true;

    if (category === 'rollNumber') {
      const sortOrder = this.sortSelectionData[category].options[index].value;
      const isAllowed = await this.checkSortByRollNumber();
    }
  }

  // Check if sorting by roll number is allowed
  async checkSortByRollNumber(): Promise<boolean> {
    const payload = {
      lang: 'en',
      academicId: this.academicId,
      classCategoryId: this.selectedWings.length === 1 ? this.selectedWings[0].categoryId : null,
      classStandardId: this.selectedClasses.length === 1 ? this.selectedClasses[0].pkClassStandardsId : null,
      classId: this.selectedSections.length === 1 ? this.selectedSections[0].classId : null,
      selectedFilter: this.appliedStatus.value
    };

    try {
      const response: any = await firstValueFrom(this.service.checkSortByRollNumber(payload));
      if (response.canSortByRollNumber) {
        return true;
      } else {
        this.sortSelectionData.rollNumber.options.forEach((opt: any) => opt.isSelected = false);

        if (response.studentsWithNoRollNumber) {
          this.studentsWithNoRollNumberList = response.studentsWithNoRollNumber;
        } else {
          this.studentsWithNoRollNumberList = [];
        }

        this.openSortNotAllowedPopUp();
        return false;
      }
    } catch (err) {
      this.sortSelectionData.rollNumber.options.forEach((opt: any) => opt.isSelected = false);
      const sortError = await firstValueFrom(this.translate.get('sortError'));
      customToastr(sortError, 'error');
      return false;
    }
  }

  // Open modal when sort by roll number is not allowed
  openSortNotAllowedPopUp() {
    this.isSortNotAllowedModalOpen = true;
  }

  // Close sort not allowed modal
  closeSortNotAllowedPopUp() {
    this.isSortNotAllowedModalOpen = false;
  }

  // Handle export button click - show column selection or export directly
  handleExportButtonClick() {
    if (this.appliedSections.length === 1) {
      this.openColumnSelectionModal();
    } else {
      this.exportClassViewReport();
    }
  }

  // Open column selection modal for table view export
  async openColumnSelectionModal() {
    this.isExportingReport = true;
    try {
      const payload = {
        academicId: this.academicId,
        lang: "en"
      }
      const response: any = await firstValueFrom(this.service.getExportColumnsForFeesOverdueReport(payload));
      if (response.status && response.body) {
        this.exportColumns = response.body.map((col: any) => ({
          ...col,
          name: col.columnName,
          key: col.slug,
          isSelected: true
        }));
        this.selectedExportColumns = this.exportColumns.filter(col => col.isSelected);
        this.selectAllExportColumns = this.exportColumns.every(col => col.isSelected);
        $("#columnSelectionModal").modal("show");
      } else {
        const errorInFetchingColumn = await firstValueFrom(this.translate.get('columnFetchError'));
        customToastr(errorInFetchingColumn, 'error');
      }
    } catch (error) {
      let errorMessage = error?.error?.message || error?.message;
      if (!errorMessage) {
        errorMessage = await firstValueFrom(
          this.translate.get('columnFetchError')
        );
      }
      customToastr(error.error.message || errorMessage, 'error');
    } finally {
      this.isExportingReport = false;
    }
  }

  // Close column selection modal
  closeColumnSelectionModal() {
    $("#columnSelectionModal").modal("hide");
  }

  // Export class view report as Excel file
  async exportClassViewReport() {
    this.isExportingReport = true;
    try {
      const payload = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: this.appliedWings.length === this.wingListData.length && this.wingListData.length > 1 ? "All" : [].concat(this.appliedWings.length === 1 && this.wingListData.length === 1 ? this.appliedWings[0].categoryId : this.appliedWings.map(w => w.categoryId)),
        classStandardId: this.appliedClasses.length === this.classStandardData.length && this.classStandardData.length > 1 ? "All" : [].concat(this.appliedClasses.length === 1 && this.classStandardData.length === 1 ? this.appliedClasses[0].pkClassStandardsId : this.appliedClasses.map(c => c.pkClassStandardsId)),
        classId: this.appliedSections.length === this.classSectionData.length && this.classSectionData.length > 1 ? "All" : [].concat(this.appliedSections.length === 1 && this.classSectionData.length === 1 ? this.appliedSections[0].classId : this.appliedSections.map(s => s.classId)),
        studentList : "All",
        termId: this.getFeeIds('termFees'),
        typeId: this.getFeeIds('typeFees'),
        busId: this.getFeeIds('transportFees'),
        otherFeeId: this.getFeeIds('otherFees'),
        selectedFilter: this.appliedStatus.value,
        reportType: this.strings.classView
      };
      const response: any = await firstValueFrom(this.service.exportFeesOverdueReport(payload));
      if (response && response instanceof Blob && response.size > 0) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = url;
        a.download = `FEES_OVERDUE_REPORT.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
        customToastr(successMsg, "success");
      }
    } catch (error) {
      let errorMessage = error?.error?.message || error?.message;
      if (!errorMessage) {
        errorMessage = await firstValueFrom(
          this.translate.get('failedtoexportreport')
        );
      }
      customToastr(error.error.message || errorMessage, 'error');
    } finally {
      this.isExportingReport = false;
    }
  }

  // Toggle select/deselect all export columns
  toggleSelectAllExportColumns() {
    this.selectAllExportColumns = !this.selectAllExportColumns;
    this.exportColumns.forEach(col => col.isSelected = this.selectAllExportColumns);
    this.updateSelectedExportColumns();
  }

  // Toggle individual export column selection
  toggleExportColumn(index: number) {
    this.exportColumns[index].isSelected = !this.exportColumns[index].isSelected;
    this.updateSelectAllState();
    this.updateSelectedExportColumns();
  }

  // Update select all checkbox state based on column selections
  updateSelectAllState() {
    this.selectAllExportColumns = this.exportColumns.every(col => col.isSelected);
  }

  // Update selected export columns array
  updateSelectedExportColumns() {
    this.selectedExportColumns = this.exportColumns.filter(col => col.isSelected);
  }

  // Export table view report with selected columns as Excel file
  async exportTableViewReport() {
    if (this.selectedExportColumns.length === 0) {
      const emptySelectionError = await firstValueFrom(this.translate.get('selectAtLeastOneColumn'));
      customToastr(emptySelectionError, 'error');
      return;
    }
    this.isExportingReport = true;
    try {
      const payload = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: this.appliedWings.length === this.wingListData.length && this.wingListData.length > 1 ? "All" : [].concat(this.appliedWings.length === 1 && this.wingListData.length === 1 ? this.appliedWings[0].categoryId : this.appliedWings.map(w => w.categoryId)),
        classStandardId: this.appliedClasses.length === this.classStandardData.length && this.classStandardData.length > 1 ? "All" : [].concat(this.appliedClasses.length === 1 && this.classStandardData.length === 1 ? this.appliedClasses[0].pkClassStandardsId : this.appliedClasses.map(c => c.pkClassStandardsId)),
        classId: this.appliedSections.length === this.classSectionData.length && this.classSectionData.length > 1 ? "All" : [].concat(this.appliedSections.length === 1 && this.classSectionData.length === 1 ? this.appliedSections[0].classId : this.appliedSections.map(s => s.classId)),
        termId: this.getFeeIds('termFees'),
        typeId: this.getFeeIds('typeFees'),
        busId: this.getFeeIds('transportFees'),
        otherFeeId: this.getFeeIds('otherFees'),
        studentList: this.appliedStudent.length === this.studentList.length ? "All" : this.appliedStudent.map(s => s.studentId),
        selectedFilter: this.appliedStatus.value,
        sortBy: this.getSortBy(),
        sortOrder: this.getSortOrder(),
        selectedColumns: this.selectedExportColumns.map(col => col.pkReportColumnMapDetailId),
        reportType: this.strings.studentView
      };
      const response: any = await firstValueFrom(this.service.exportFeesOverdueReport(payload));


      if (response && response instanceof Blob && response.size > 0) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = url;
        a.download = `FEES_OVERDUE_REPORT.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
        customToastr(successMsg, "success");
        this.closeColumnSelectionModal();
      }
    } catch (error) {
      let errorMessage = error?.error?.message || error?.message;
      if (!errorMessage) {
        errorMessage = await firstValueFrom(
          this.translate.get('failedtoexportreport')
        );
      }
      customToastr(error.error.message || errorMessage, 'error');
    } finally {
      this.isExportingReport = false;
      this.closeColumnSelectionModal();
    }
  }

  // Generate page numbers array for pagination display
  generatePageNumbers() {
    const pages: any[] = [];
    const maxPagesToShow = 5;

    if (this.maxPageNumber <= maxPagesToShow) {
      for (let i = 1; i <= this.maxPageNumber; i++) {
        pages.push(i);
      }
    } else {
      if (this.startingPageNumber <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.maxPageNumber);
      } else if (this.startingPageNumber >= this.maxPageNumber - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = this.maxPageNumber - 3; i <= this.maxPageNumber; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(this.startingPageNumber - 1);
        pages.push(this.startingPageNumber);
        pages.push(this.startingPageNumber + 1);
        pages.push('...');
        pages.push(this.maxPageNumber);
      }
    }

    this.pageNumbers = pages;
  }

  // Navigate to specific page
  goToPage(page: any) {
    if (page === '...' || page === this.startingPageNumber) {
      return;
    }
    this.startingPageNumber = page;
    if (this.appliedSections.length === 1) {
      this.tableViewCurrentPage = page;
    } else {
      this.classViewCurrentPage = page;
    }

    this.generatePageNumbers();
    this.tileDataOrTableData();
  }

  // Navigate to next page
  nextPage() {
    if (this.startingPageNumber < this.maxPageNumber) {
      this.startingPageNumber++;
      if (this.appliedSections.length === 1) {
        this.tableViewCurrentPage = this.startingPageNumber;
      } else {
        this.classViewCurrentPage = this.startingPageNumber;
      }

      this.generatePageNumbers();
      this.tileDataOrTableData();
    }
  }

  // Navigate to previous page
  previousPage() {
    if (this.startingPageNumber > 1) {
      this.startingPageNumber--;
      if (this.appliedSections.length === 1) {
        this.tableViewCurrentPage = this.startingPageNumber;
      } else {
        this.classViewCurrentPage = this.startingPageNumber;
      }

      this.generatePageNumbers();
      this.tileDataOrTableData();
    }
  }

  // Handle class view page limit change
  onPageLimitChange(event: any) {
    this.classViewPageLimit = parseInt(event.target.value, 10);
    this.startingPageNumber = 1;
    this.classViewCurrentPage = 1;
    this.tileDataOrTableData();
  }

  // Handle table view page limit change
  onTablePageLimitChange(event: any) {
    this.tableViewPageLimit = parseInt(event.target.value, 10);
    this.startingPageNumber = 1;
    this.tableViewCurrentPage = 1;
    this.tileDataOrTableData();
  }
}
